"use strict";

import Page from "./AddManagementPermission.tsx";

export const auth = true;
export const title =
  "i18n:accountPermissions.permissionInternalUser.addManagementPermission";
export const Component = Page;
